import styled, { css } from 'styled-components'

export const SCROLL_FADE_HEIGHT_CATALOG = '8px'
export const SCROLL_FADE_HEIGHT_GRID = '24px'

export const scrollFadeDarkDown = css`
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.09),
    rgba(0, 0, 0, 0.03) 50%,
    transparent
  );
`

export const scrollFadeDarkUp = css`
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.09),
    rgba(0, 0, 0, 0.03) 50%,
    transparent
  );
`

const scrollFadeLightDown = css`
  background: linear-gradient(to bottom, #fff, transparent);
`

const scrollFadeLightUp = css`
  background: linear-gradient(to top, #fff, transparent);
`

const scrollFadeLightRight = css`
  background: linear-gradient(to right, transparent, #fff);
`

const scrollFadeDarkRight = css`
  width: 1px;
  background: ${({ theme }) => theme.colors.gray3};
`

const fadeBase = $visible => css`
  position: absolute;
  z-index: 3;
  pointer-events: none;
  opacity: ${$visible ? 1 : 0};
  transition: opacity 0.15s ease;
`

export const ScrollFadeTop = styled.div`
  ${({ $visible, $topOffset, $height, $variant }) => css`
    ${fadeBase($visible)}
    top: ${$topOffset || 0};
    left: 0;
    right: 0;
    height: ${$height};
    ${$variant === 'light' ? scrollFadeLightDown : scrollFadeDarkDown}
  `}
`

export const ScrollFadeBottom = styled.div`
  ${({ $visible, $height, $variant }) => css`
    ${fadeBase($visible)}
    bottom: 0;
    left: 0;
    right: 0;
    height: ${$height};
    ${$variant === 'light' ? scrollFadeLightUp : scrollFadeDarkUp}
  `}
`

export const ScrollFadeRight = styled.div`
  ${({ $visible, $height, $topOffset, $variant }) => css`
    ${fadeBase($visible)}
    top: ${$topOffset || 0};
    right: 0;
    bottom: 0;
    width: ${$height};
    ${$variant === 'light' ? scrollFadeLightRight : scrollFadeDarkRight}
  `}
`
